import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { AccountingActionEnum } from "./accounting-action-enum";

/**
 * Allowed COA types for actions when used at the customer (Kustomisasi Akun
 * Penjualan) context. These are narrower than the global
 * AccountingActionAllowedTypes — Accurate enforces a stricter whitelist at the
 * customer level than at the org-level Preferensi Akun page.
 */
export const CustomerAccountingActionAllowedTypes = Object.freeze({
  [AccountingActionEnum.ACCOUNTS_RECEIVABLE]: [
    ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE,
  ],
  [AccountingActionEnum.SALES_DOWN_PAYMENT]: [
    ChartOfAccountTypeEnum.ACCOUNTS_PAYABLE,
  ],
  [AccountingActionEnum.SALES_REVENUE]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES,
  ],
  [AccountingActionEnum.ITEM_DISCOUNT]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],
  [AccountingActionEnum.COST_OF_GOODS_SOLD]: [
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
  ],
  [AccountingActionEnum.SALES_RETURN]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],
  [AccountingActionEnum.SALES_DISCOUNT]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
});
